import { Tokens } from '@/assets/tokens'
import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
from {
  transform: translateY(100vh);
}
to {
  transform: translateY(0);
}
`

export const ContentContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow-y: auto;
  background-color: ${Tokens.ColorHover};
  animation: ${fadeIn} 0.25s ease-in-out forwards;
`

export const Content = styled.section`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem;
  min-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 40px;

  @media (max-width: 768px) {
    padding: 0.75rem;
    gap: 32px;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
    gap: 24px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`

export const ParentTitle = styled.h6`
  font-weight: 400;
  color: ${Tokens.ColorTextPrimary};
  padding-bottom: 3px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    text-decoration-color: inherit;
  }
`
